<!--
Voting election selection screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
    <Nav name="Voting" />
    <Spinner ref="spinner_ref" />
    <div class="vContainer">
      <img src="@/assets/voteStart.svg" id="voteStartImg" />
      <p id="votingStartHdr">Are you ready to vote?</p>
      <p id="votingSubmitMsg">
        Select the candidates to best represent you!
      </p>
      <div class="list-group">
        <button v-on:click="voteLogin" class="list-group-item" id="votingStart" tabindex="0">
          Get Voting
        </button>
    </div>
     <!-- voting time message if rquired <p style="text-align:center;margin-top:24px;font-weight:700">Voting Opens at 9am on Thursday 15th October</p> -->
    </div>
    <NewModalPopup v-if="showMessagePopup" hideTitleBar="true" :id="'confirm'+bookingId" title="Confirm">
     <div class="confHdr">Alert</div>
     <div class="confText"><span v-html="infoMsg"></span></div>
      <table class="cancel-rb" role="group" aria-label="cancellation buttons">
        <tr>
          <td>
            <button class="btn-choice-cancel" @click="clickOk(() => router.push('/'))">OK</button>
          </td>
        </tr>
      </table>
     </NewModalPopup>
  </div>
</template>

<script setup>
import axios from 'axios'
import * as lst from '@/components/localStorage.js'
import NewModalPopup from '@/components/NewModalPopup.vue'

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute()
const spinner_ref = ref(null)
const infoMsg = ref('')
const showMessagePopup = ref(false)
const okCallback = ref(null)

onMounted (() => {
    const ua = window.navigator.userAgent
    const ie11 = ua.indexOf('rv:11.0') !== -1
    if (ie11) {
      alert('Sorry, the Voting System is no longer supported on Internet Explorer. Please login again using the Chrome, FireFox or Edge browsers.')
      router.push('/')
    }
    if (route.params.skip) {
      voteLogin()
    }
  })

  function clickOk(okCallback) {
    showMessagePopup.value = false
    // and do callback if we were given one
    if (okCallback !== null) {
      okCallback()
    }
  }
  function showMessage(msg, callback) {
    infoMsg.value = msg
    showMessagePopup.value = true
    // TODO handle callback
    if (typeof callback !== 'undefined') {
      okCallback.value = callback
    } else {
      okCallback.value = null
    }
  }

  function voteLogin () {
      spinner_ref.value.spin()
      axios.post('/vote/rest/login', {
        guid: lst.getValue('guid'),
        token: lst.getValue('token')
      })
        .then(response => {
          if (response.data == 'OK') {
            router.push('/voting/election')
          } else if (response.data == 'COLLEGE') {
            router.push('/voting/college')
          } else if (response.data == 'SCHOOL') {
            router.push('/voting/school')
          } else {
            showMessage(response.data,
              () => {
                router.push('/')
              })
          }
          spinner_ref.value.stop()
        })
        .catch(error => {
          if (error.response.data.error == "You don't have record for the current academic session.") {
            showMessage("There may be a problem with your registration records. Please check our <a href=\"https://glasgow.saasiteu.com/Modules/SelfService/#knowledgeBase/view/D5BFD3517E5A4FD2AA9EED0655A754D3\" target=\"blank\">KB article</a> article for further information on how to vote and then log a call with the UofG Life App team via the Helpdesk.",
              () => {
                router.push('/')
              })
          } else {
            showMessage(error.response.data.error,  () => {
              router.push('/')
            })
          }
        })
    }
  

</script>
<style>

.vContainer {
  margin-left:24px;
  margin-right:24px;
}
#votingStart {
  border: 1px solid #003865;
  background-color:#003865;
  color:#ffffff;
  text-align:center;

  font-weight:700;
  border-radius:12px;
  width:100%;
}

#voteStartImg {
  margin-top:10px;
  margin-right:auto;
  margin-left:auto;
  display:block;
  padding-right:5%;
}

#votingStartHdr {
  font-weight: bold;
  font-size: 25px;
  text-align:center;
  color:#003865;
}
</style>
